import React from "react";
import { Breadcrumb } from "antd";
import { Link, useNavigate } from "react-router-dom";
import svg4 from "../assets/svg/svg4.svg";

export default function BreadCrumb({ breadcrumbs = [] }) {
  const navigate = useNavigate();
  return (
    <Breadcrumb className="  py-[.5rem]" separator="/">
      <Breadcrumb.Item>
        <span className="flex items-center gap-x-[.88rem]">
          <img src={svg4} alt="" className="w-4 h-4" />
          <Link to="/dashboard">Overview</Link>
        </span>
      </Breadcrumb.Item>

      {breadcrumbs?.map((item, index) => {
        const isLast = index === breadcrumbs?.length - 1;

        const backSteps = -(breadcrumbs?.length - index - 1);

        return (
          <Breadcrumb.Item key={index}>
            {isLast ? (
              item?.title
            ) : item?.path === "back" ? (
              <span
                className="cursor-pointer"
                onClick={() => navigate(backSteps)}
              >
                {item?.title}
              </span>
            ) : (
              <Link to={item?.path}>{item?.title}</Link>
            )}
          </Breadcrumb.Item>
        );
      })}
    </Breadcrumb>
  );
}
